export default __webpack_public_path__ + "static/media/background.250aa0a9.png";